import { render } from "./box-total-exit.vue?vue&type=template&id=57a5ecd6"
import script from "./box-total-exit.vue?vue&type=script&lang=js"
export * from "./box-total-exit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__